<cigna-modal #legalAffirmationModal [options]="{ class: 'cigna-modal-md' }">
  <cigna-modal-layout
    [title]="'Legal Affirmation' | translate"
    [close]="'Close' | translate"
    class="legal-affirmation-modal-layout"
  >
    <div class="auth-paragraph">
      <p>
        I <span>{{ firstName$ | async | titlecase }}</span
        >, {{ 'broker.compensation.manage.legalAffirmText' | translate }}
      </p>
    </div>
    <div class="brk-spinner" *ngIf="isLoadingAppShared === false">
      <cigna-spinner hint="Loading..." size="large"> </cigna-spinner>
    </div>
    <div class="agency-failed-container" *ngIf="isGetAgencyFailed">
      <h1 class="page-failed">
        {{ 'broker.compensation.manage.apiFailTextLegal' | translate }}
        <span
          class="failed-link"
          (click)="
            isImpersonatorFlag ? openContactUsModal() : navigateContactUs()
          "
        >
          {{ 'broker.compensation.Contactus' | translate }}.
        </span>
      </h1>
    </div>
    <div *ngIf="!isGetAgencyFailed" class="legal-affirmation-list-wrap">
      <div
        *ngFor="let agency of agencyList"
        class="legal-affirmation-table"
        data-test-id="legal-affirmation-table"
      >
        <div class="legal-affirmation-name-wrapper">
          <div
            class="legal-affirmation-name"
            data-test-id="legalAffirmName"
            attr.aria-label="lblLegalAffirmName-{{ agency.name }}"
          >
            {{ agency.name | titlecase }}
          </div>
        </div>
        <div class="legal-affirmation-address-wrapper">
          <div
            class="agency-office-address"
            data-test-id="lblLegalAffirmAddress"
            attr.aria-label="lblLegalAffirmAddress-{{
              agency.correspondence_address
            }}"
          >
            {{
              agency?.correspondence_address?.split(',')[0]
                ? (agency?.correspondence_address?.split(',')[0] | titlecase) +
                  ', '
                : ''
            }}
            {{
              agency?.correspondence_address?.split(',')[1]
                ? (agency?.correspondence_address?.split(',')[1] | titlecase) +
                  ', '
                : ''
            }}
            {{ agency?.correspondence_address?.split(',')[2]?.split('-')[0] }}
            {{ agency?.correspondence_address?.split(',')[2]?.split('-')[1] }}
          </div>
        </div>
      </div>
    </div>
  </cigna-modal-layout>
  <div class="legal-affirmation-footer">
    <button
      mat-raised-button
      cg-mat-btn-type="primary"
      [disabled]="isImpersonatorFlag || isGetAgencyFailed"
      class="btn-medium"
      type="sub"
      (click)="submitLegalAffirmFn()"
      data-test-id="btnSubmitLegalAffirmFn"
    >
      I Agree
    </button>

    <a
      (click)="goToManageAccess()"
      class="legal-affirmation-text"
      data-test-id="lnkToManageAccess"
    >
      {{ 'broker.compensation.manage.manageAccess' | translate }}</a
    >

    <a
      (click)="closeLegalAffirmFn()"
      class="legal-affirmation-skip"
      *ngIf="isImpersonatorFlag"
      data-test-id="lnkToSkip"
      >Skip</a
    >
  </div>
</cigna-modal>
